import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Row,
  Col,
  Button,
  Space,
  Modal,
} from 'antd';
import { apiRequest } from '../../../../service/apiRequest';
import { showSuccess, showError } from '../../../../components/errorHandler';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';

import { fetcunittypeData } from '../../../../redux/slice/masterSlice';
interface UnitTypeModelProps {
  visible: boolean;
  onCancel: () => void;
  onCreate: (data: any) => void;
  initialValues?: {
    ut_id?: number;
    ut_name?: string;
  } | null;
  isEditMode?: boolean;
}

const UnitTypeModel: React.FC<UnitTypeModelProps> = ({
  visible,
  onCancel,
  onCreate,
  initialValues = null,
  isEditMode = false,
}) => {

  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [isModalClose, setIsModalClose] = useState(true);

  const isSubmitDisabled = () => {
    const errors = form.getFieldsError();
    return errors.some(({ errors }) => errors.length > 0);
  };

  const handleSubmit = async (values: any) => {
    try {
      const payload = {
        ut_name: values.ut_name,
        ...(initialValues?.ut_id && { ut_id: initialValues.ut_id }),
      };

      const url = isEditMode ? 'edit-unit-type' : 'add-unit-type';
      const method = isEditMode ? 'put' : 'post';

      const data = await apiRequest({ method, url, data: payload });

      onCreate(data);
      showSuccess(isEditMode ? 'Unit Type updated successfully!' : 'Unit Type created successfully!');
      form.resetFields();

      if (isModalClose) onCancel();
      dispatch(fetcunittypeData());
    } catch (error) {
      showError(`Failed to ${isEditMode ? 'update' : 'create'} Unit Type`);
    }
  };

  useEffect(() => {
    if (visible && isEditMode && initialValues) {
      form.setFieldsValue({ ut_name: initialValues.ut_name });
    } else if (visible) {
      form.resetFields();
    }
  }, [visible, isEditMode, initialValues, form]);

  return (
    <Modal
      title={isEditMode ? 'Edit Unit Type' : 'Add New Unit Type'}
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width="90%"
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        autoComplete="off"
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="ut_name"
              className="px-8"
              label={
                <span>
                  Unit Type&nbsp;
                  <span style={{ fontSize: '12px', color: '#888' }}>
                    (Max 255 characters)
                  </span>
                </span>
              }
              rules={[
                { required: true, message: 'Please enter the unit type name' },
                { max: 255, message: 'Maximum 255 characters allowed' },
              ]}
            >
              <Input showCount maxLength={255} placeholder="e.g., Retail, unit" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Space>
            <Button onClick={onCancel}>Cancel</Button>
            {!isEditMode && (
              <Button
                type="primary"
                htmlType="submit"
                onClick={() => setIsModalClose(false)}
                disabled={isSubmitDisabled()}
              >
                Submit & Create New
              </Button>
            )}
            <Button
              type="primary"
              htmlType="submit"
              onClick={() => setIsModalClose(true)}
              disabled={isSubmitDisabled()}
            >
              Submit
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UnitTypeModel;
